import TagComponent from './tag.component'

const TagModule = angular.module('cdbl.tag', [

])
  .component('cdblTag', TagComponent)
  .name

export default TagModule
